/**
 * Arrange the rows from GET /registrations/all (oldest first across every event) the way the
 * Attendance report's old per-event loop produced them: grouped by event in the event list's
 * order, oldest first within an event, and only for events in the list. Array sort is stable,
 * so the within-event order survives.
 */
export function orderRegistrationsByEvents<T extends { eventId: string }>(
  registrations: T[],
  events: { id: string }[],
): T[] {
  const position = new Map(events.map((e, i) => [e.id, i]));
  return registrations
    .filter((r) => position.has(r.eventId))
    .sort((a, b) => position.get(a.eventId)! - position.get(b.eventId)!);
}
